import Crud from '../components/User/Crud'

let routes = {
    path: '/app',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {            
            path: '/app',
            component: Crud
        },
    ]        
}

export default routes


// WEBPACK FOOTER //
// ./src/router/user.js